export default function transformWorkProductionData(data) {
	const entries = [
		["title", data.name],
		["imprint", data.imprint],
		["language", data.language],
		["contributors", data.contributors],
		["series", data.serie, (serie) => serie?.name || null],
		["part", data.serieNumber],
		["tags", data.tags],
		["imgThumb", data.coverThumb, (coverThumb) => coverThumb?.url || null],
	]
		.filter(([, value]) => value !== undefined)
		.map(([key, value, transform]) => [key, transform ? transform(value) : value]);

	return entries.length > 0 ? Object.fromEntries(entries) : null;
}
